import React, { forwardRef, ForwardRefRenderFunction, useMemo } from 'react';

import Icon from '@gojob/ui-bits/Icon';
import DotIcon from '@gojob/ui-bits/Icons/Dot';
import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import TouchableOpacity, { TouchableOpacityProps } from '@gojob/ui-bits/TouchableOpacity';

export interface DotProps
  extends Omit<TouchableOpacityProps<'button'>, 'ref' | 'color' | 'height' | 'width'> {
  opacity?: number;
  height?: string | number;
  width?: string | number;
}

const useStyles = () => {
  const { spacing } = useTheme();
  return useMemo(() => {
    return {
      root: {
        margin: spacing(2, 1),
        width: spacing(6),
        height: spacing(6),
      },
      dot: {
        willChange: 'opacity, width, height',
        transition: 'opacity 350ms ease-in-out, width 350ms ease-in-out, height 350ms ease-in-out',
      },
    };
  }, [spacing]);
};

const Dot: ForwardRefRenderFunction<HTMLButtonElement, DotProps> = (props, ref) => {
  const { height, width, opacity } = props;

  const {
    button: { accent },
  } = usePalette();
  const classes = useStyles();

  return (
    <TouchableOpacity ref={ref as any} css={classes.root} {...props}>
      <Icon as={DotIcon as any} css={classes.dot} color={accent} style={{ height, width, opacity }} />
    </TouchableOpacity>
  );
};

export default forwardRef(Dot);
